import { INCHES_PER_FOOT } from "rivals/shared/constants";

export const getPlayerHeightInFeet = (totalHeight?: number): number => {
  if (totalHeight) {
    return Math.floor(totalHeight / INCHES_PER_FOOT);
  } else {
    return 0;
  }
};

export const getPlayerHeightInInches = (totalHeight?: number): number => {
  if (totalHeight) {
    return Math.floor(totalHeight % INCHES_PER_FOOT);
  } else {
    return 0;
  }
};

export const getPlayerHeightInFeetAndInches = (height: number): string => {
  const feet = getPlayerHeightInFeet(height);
  const inches = getPlayerHeightInInches(height);
  return `${feet}'${inches}"`;
};
